import { useState, useEffect, useCallback, useRef } from "react";

export const useListPagination = (listLength) => {
  const [toShow, setToShow] = useState(25);
  const [pCounter, setPCounter] = useState([]);
  const [pFrom, setPFrom] = useState(0);
  const [pTo, setPTo] = useState(25);
  const [cFrom, setCFrom] = useState(0);
  const [cTo, setCTo] = useState(5);
  const prevListLengthRef = useRef(listLength);

  useEffect(() => {
    const pages = Math.ceil(listLength / toShow) || 0;
    setPCounter(Array.from(Array(pages).keys()));
  }, [listLength, toShow]);

  useEffect(() => {
    setPFrom(0);
    setPTo(toShow);
    setCFrom(0);
    setCTo(5);
  }, [toShow]);

  useEffect(() => {
    if (listLength < prevListLengthRef.current) {
      setPFrom(0);
      setPTo(toShow);
      setCFrom(0);
      setCTo(5);
    }
    prevListLengthRef.current = listLength;
  }, [listLength, toShow]);

  const showPaggination = useCallback(
    (number) => {
      const val = number * toShow;
      setCFrom(number);
      setCTo(number + 5);
      setPFrom(val);
      setPTo(val + toShow);
      window.scrollTo(0, 0);
    },
    [toShow],
  );

  const UpPaggination = useCallback(() => {
    setCFrom((prev) => prev + 1);
    setCTo((prev) => prev + 1);
    setPFrom((prev) => prev + toShow);
    setPTo((prev) => prev + toShow);
    window.scrollTo(0, 0);
  }, [toShow]);

  const downPaggination = useCallback(() => {
    setCFrom((prev) => prev - 1);
    setCTo((prev) => prev - 1);
    setPFrom((prev) => prev - toShow);
    setPTo((prev) => prev - toShow);
    window.scrollTo(0, 0);
  }, [toShow]);

  const toShowFun = useCallback((num) => {
    setToShow(num);
    setPFrom(0);
    setPTo(num);
    setCFrom(0);
    setCTo(5);
    window.scrollTo(0, 0);
  }, []);

  const resetPagination = useCallback(() => {
    setToShow(25);
    setPFrom(0);
    setPTo(25);
    setCFrom(0);
    setCTo(5);
  }, []);

  const isRowVisible = useCallback(
    (index) => index >= pFrom && index < pTo,
    [pFrom, pTo],
  );

  return {
    toShow,
    pFrom,
    pTo,
    pCounter,
    cFrom,
    cTo,
    isRowVisible,
    showPagination: listLength > toShow,
    showPaggination,
    UpPaggination,
    downPaggination,
    toShowFun,
    resetPagination,
  };
};
